import { BiLogoGoLang } from "react-icons/bi";
import {
  DiDjango,
  DiDocker,
  DiMongodb,
  DiMysql,
  DiPython,
  DiReact,
} from "react-icons/di";
import { SiNodedotjs, SiRust, SiTypescript } from "react-icons/si";
import Skill from "./Skill";
import "./skills.css";

const skills = [
  {
    name: "Rust",
    img: <SiRust className="skillIcon" />,
  },
  {
    name: "Python",
    img: <DiPython className="skillIcon" />,
  },
  {
    name: "TypeScript",
    img: <SiTypescript className="skillIcon" />,
  },
  {
    name: "GoLang",
    img: <BiLogoGoLang className="skillIcon" />,
  },
  {
    name: "React JS",
    img: <DiReact className="skillIcon" />,
  },
  {
    name: "NodeJS",
    img: <SiNodedotjs className="skillIcon" />,
  },
  {
    name: "Django",
    img: <DiDjango className="skillIcon" />,
  },
  {
    name: "Docker",
    img: <DiDocker className="skillIcon" />,
  },
  {
    name: "MySQL",
    img: <DiMysql className="skillIcon" />,
  },
  {
    name: "MongoDB",
    img: <DiMongodb className="skillIcon" />,
  },
];

const renderedSkills = [...skills, ...skills];

const Skills = () => {
  return (
    <>
      <hr className="homeLine" />
      <div className="skillsContainer">
        <h1 className="homeHeading">Skills</h1>
        <div className="allSkillsContainer">
          {renderedSkills.map((skill, index) => {
            return (
              <Skill
                key={index}
                skill={{
                  name: skill.name,
                  img: skill.img,
                }}
              />
            );
          })}
        </div>
      </div>
    </>
  );
};

export default Skills;
